"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const firm_billing_types_1 = require("../user/firm-billing-types");
exports.testSalesforcePersonAccountRecord = {
    Id: 'testSalesforceId',
    PersonIndividualId: 'testPersonIndividualId',
    RV_ACIPA_ID__c: 'testAicpaId',
    RV_OktaID__pc: 'testOktaId',
    PersonEmail: 'TestFirstname.TestLastName@test.com',
    FirstName: 'TestFirstname',
    LastName: 'TestLastName',
    Phone: '07123456789',
    SFS_PAC_IsHonorary__c: false,
    Account_Auto_Number__c: 'testSalesforceAccountNumber',
    Gender__pc: types_1.MembershipTypes.Gender.MAN,
    SFS_APA_AccountId__c: 'testSFS_APA_AccountId__c',
    SFS_PAC_GenderSpecific__c: '',
    SFS_PAC_GenderConsent__c: false,
    SFS_PAC_Ethnicity__c: '',
    SFS_PAC_EthnicitySpecific__c: '',
    SFS_PAC_EthnicityConsent__c: false,
    SFS_PAC_EthicsStatus__c: types_1.MembershipTypes.EthicsStatusEnum.NONE,
    SFS_PAC_EthicsNote__c: '',
    PersonBirthdate: '1970-01-01',
    attributes: {
        type: types_1.SalesforceResponses.SalesforceRecordTypes.ACCOUNT,
        url: '/services/data/v52.0/sobjects/Account/testSalesforceId',
    },
    PersonContactId: 'testPersonContactId',
    SFS_PAC_Pathway__c: types_1.MembershipTypes.Pathway.AICPA_NON_FLP,
};
exports.testSalesforceAccountPersonAccountRecord = {
    Id: 'testAccountPersonAccountSalesforceId',
    IsDeleted: false,
    Name: 'testAccountPersonAccountSalesforceName',
    SFS_APA_IsActiveFlag__c: true,
    SFS_APA_AccountId__c: '0013K00000jf5peQAA',
    SFS_APA_AccountId__r: {
        Name: 'testOrgName',
        SFS_ACC_NFOrganizationKey__c: '',
        SFS_ACC_OrgEmail__c: '',
        SFS_PAC_NFIndividualKey__c: '',
    },
    SFS_APA_PersonAccountKey__r: Object.assign(Object.assign({}, exports.testSalesforcePersonAccountRecord), { Id: 'testSalesforceIdEmployee' }),
    SFS_APA_FBDataConsent__c: '',
    SFS_APA_PersonAccountKey__c: 'testSalesforceId',
    SFS_APA_RelationshipType__c: 'Client Admin',
    SFS_APA_AdminType__c: types_1.Salesforce.AccountContactRole.CENTERS_ADMIN,
    SFS_APA_JobTitle__c: '',
    SFS_APA_CentersAlertsConsent__c: true,
    SFS_APA_StartDate__c: 'testDate',
    SFS_APA_EndDate__c: '',
    LastModifiedDate: 'testDate',
    SFS_APA_IsPrimary__c: true,
    CreatedDate: 'testDate',
    CreatedById: 'integrationUserId',
    LastModifiedById: 'integrationUserId',
    SFS_APA_OrgAddressFlag__c: 'false',
    SFS_APA_OrgEmailFlag__c: 'false',
    SFS_APA_OrgPhoneFlag__c: 'false',
    SFS_APA_PAAddressLookup__c: '',
    SFS_APA_PAEmailLookup__c: '',
    SFS_APA_PAPhoneLookup__c: '',
    SFS_APA_NFRelationshipKey__c: '',
    SFS_APA_OrgAddressType__c: '',
    Learning_Pathway: '',
};
const errors = [];
exports.testSalesforceCreateResponse = {
    id: 'testSalesforceId',
    success: true,
    errors,
};
exports.testSalesforceAccountRecord = {
    Id: '0013K00000jf5peQAA',
    Name: 'ABG Limited',
    SFS_ACC_FBAICPA__c: 'FBE Renewing',
    RV_IsCreditHold__c: false,
    RV_ACIPA_ID__c: 'aicpa Id 1',
    Phone: '-',
    Type: 'Account',
    SFS_ACC_FBFLP__c: 'Firm Billing Admin',
    attributes: { type: types_1.SalesforceResponses.SalesforceRecordTypes.ACCOUNT },
    ParentId: 'string',
    RV_OktaID__pc: 'string',
    PersonEmail: 'string',
    FirstName: 'string',
    MiddleName: 'string',
    LastName: 'string',
    Account_Auto_Number__c: 'string',
    Gender__pc: types_1.MembershipTypes.Gender.MAN,
    SFS_APA_AccountId__c: 'string',
    SFS_PAC_GenderSpecific__c: 'string',
    SFS_PAC_GenderConsent__c: false,
    SFS_PAC_Ethnicity__c: 'string',
    SFS_PAC_EthnicitySpecific__c: 'string',
    SFS_PAC_EthnicityConsent__c: false,
    SFS_PAC_EthicsStatus__c: types_1.MembershipTypes.EthicsStatusEnum.NONE,
    SFS_PAC_EthicsNote__c: 'string',
    SFS_PAC_SiebelID__c: 'string',
    PersonBirthdate: 'string',
    PersonContactId: 'string',
    OrganizationType: 'string',
    SFS_ACC_FBCIMA__c: '',
    SFS_ACC_IsB2BPremium__c: false,
    Website: 'string',
    ShippingCountry: 'string',
    ShippingState: 'string',
    ShippingCity: 'string',
    ShippingPostalCode: 'string',
    ShippingStreet: 'string',
    Ship_to_Billing_Address__c: true,
    BillingCountry: 'USA',
    BillingState: 'NC',
    BillingCity: 'Durham',
    BillingPostalCode: '27707-8110',
    BillingStreet: '220 Leigh Farm Road',
    Account_Portfolio__c: 'string',
    RV_InstalmentTerm__c: 'string',
    RV_PaymentTerm__c: 'string',
    SFS_PAC_DateSyncWithPV__c: 'string',
    SFS_PAC_PVCandidateID__c: 'string',
    RecordTypeId: '',
    Active__c: true,
};
const branches = [];
exports.testSalesforceAccountRecordWithBranches = Object.assign(Object.assign({}, exports.testSalesforceAccountRecord), { branches });
exports.testSalesforceContactPointAddressRecord = {
    Id: '8lW3K000000A694UAC',
    ParentId: '0PK3K0000004PvnWAE',
    /**
     * @deprecated Deprecated field
     */
    SFS_ADD_IndividualKey__c: '0PK3K0000004PvnWAE',
    Street: '',
    City: 'Jamaica Plain',
    State: 'MA',
    PostalCode: '2130',
    Country: 'USA',
    IsPrimary: true,
    Latitude: '',
    Longitude: '',
    SFS_ADD_AddressType__c: '',
    SFS_ADD_Line1__c: '10 John a Andrew St',
    SFS_ADD_Line2__c: '',
};
exports.testSalesforcePersonAccountEmailRecord = {
    Id: 'testEmailId2',
    SFS_EMA_IndividualKey__r: { Id: 'testId1', SFS_IND_Email__c: '' },
    EmailAddress: 'sample@email.com',
    IsPrimary: true,
};
exports.testSalesforceAccountPersonAccountRecordEmployee = Object.assign(Object.assign({}, exports.testSalesforceAccountPersonAccountRecord), { Id: 'testSalesforceIdEmployee', SFS_APA_RelationshipType__c: 'Firm Billing', SFS_APA_PersonAccountKey__c: 'testSalesforceIdEmployee', SFS_APA_AdminType__c: '' });
exports.testSalesforceAccountPersonAccountRecordAdmin = Object.assign(Object.assign({}, exports.testSalesforceAccountPersonAccountRecord), { Id: 'testSalesforceIdAdmin', SFS_APA_RelationshipType__c: 'Admin', SFS_APA_PersonAccountKey__c: 'testSalesforceIdAdmin', SFS_APA_AdminType__c: '' });
exports.testSalesforceMembershipCombinedRecord = {
    SFS_MBT_MembershipKey__c: '',
    attributes: {
        type: types_1.SalesforceResponses.SalesforceRecordTypes.MEMBERSHIP,
    },
    Id: '',
    Name: '',
    SFS_MBT_IsPaidByFirm__c: true,
    SFS_MBT_ProductSKU__c: 'Regular',
    SFS_MBT_MembershipKey__r: {
        attributes: {
            type: types_1.SalesforceResponses.SalesforceRecordTypes.MEMBERSHIP_TERM,
        },
        Id: '',
        Name: '',
        SFS_MEM_AccountKey__c: 'testSalesforceIdEmployee',
        SFS_MEM_AdminAccountKey__c: 'personId1',
        SFS_MEM_FirmMembershipType__c: 'CAQ - Regular',
        SFS_MEM_EndDate__c: '',
        SFS_MEM_MembershipBody__c: '',
        SFS_MEM_MemberSinceDate__c: '',
        SFS_MEM_Status__c: 'Active',
    },
    SFS_MBT_ApplicationPartKey__c: 'recordId2',
    SFS_MBT_ExpiryDate__c: '2024-08-19',
    CreatedDate: '2023-08-19',
};
exports.testSalesforceApplicationComposite = {
    attributes: {
        type: types_1.SalesforceResponses.SalesforceRecordTypes.APPLICATION_PART,
        url: '/services/data/v52.0/sobjects/Application__c/testId1',
    },
    Id: 'testId1',
    Name: '',
    SFS_APP_AccountKey__c: 'adminId1',
    SFS_APP_ApplicationProgress__c: '',
    SFS_APP_ApproveDate__c: '',
    SFS_APP_ApproverKey__c: '',
    SFS_APP_CreatedByKey__c: '0013K00000xBODIQA4',
    SFS_APP_EmploymentRole__c: '',
    SFS_APP_StartDate__c: '2023-08-19',
    SFS_APP_StatusReason__c: '',
    SFS_APP_Status__c: types_1.MembershipTypes.ApplicationStatusEnum.APPROVED,
    SFS_APP_SubmitDate__c: '',
    CreatedDate: '2023-08-19T19:37:56.000+0000',
    Application_Parts__r: {
        totalSize: 1,
        done: true,
        records: [
            {
                attributes: {
                    type: types_1.SalesforceResponses.SalesforceRecordTypes.APPLICATION_PART,
                    url: '/services/data/v52.0/sobjects/Application_Part__c/recordId1',
                },
                Id: 'recordId1',
                Name: '',
                SFS_APT_ProductSKU__c: 'sku1',
                SFS_APP_StartDate__c: '',
            },
        ],
    },
};
exports.testGetFirmBillingEmployeesResponse = {
    firmRosterMembers: [firm_billing_types_1.testFirmRosterMember],
    organizationCapabilityType: types_1.B2B.OrganizationCapabilityType.AICPA,
};
//# sourceMappingURL=index.js.map